export const DVIR_TEMPLATES = 'DVIR_TEMPLATES';
export const DVIR_BUSY = 'DVIR_BUSY';
export const DVIR_ALL = 'DVIR_ALL';
export const DVIR_COUNT = 'DVIR_COUNT';
